module.exports = __webpack_public_path__ + "img/ic_kontakt.4144bf04.svg";